interface TaxonomyTerm {
  id: string
  title: string
  slug: string
}

export const useTaxonomyFilter = (
  queryParamName: string,
  terms: Ref<TaxonomyTerm[]>,
) => {
  const route = useRoute()
  const router = useRouter()

  // Init from URL query params
  const paramValue = route.query[queryParamName]
  const initialSlugs = typeof paramValue === 'string' && paramValue
    ? paramValue.split(',').filter(s => terms.value.some(term => term.slug === s))
    : []

  const selectedSlugs = ref<string[]>(initialSlugs)
  const filterAll = ref(initialSlugs.length === 0)

  function onAllChange(checked: boolean) {
    if (checked) {
      filterAll.value = true
      selectedSlugs.value = []
    }
  }

  function onTermChange(slug: string, checked: boolean) {
    if (checked) {
      selectedSlugs.value = [...selectedSlugs.value, slug]
      filterAll.value = false
    } else {
      selectedSlugs.value = selectedSlugs.value.filter(s => s !== slug)
      // Re-check "All" if no terms remain selected
      if (selectedSlugs.value.length === 0) {
        filterAll.value = true
      }
    }
  }

  // Sync selectedSlugs to URL query params
  watch(selectedSlugs, (slugs) => {
    const query = Object.fromEntries(
      Object.entries(route.query).filter(([key]) => key !== queryParamName),
    )

    if (slugs.length > 0) {
      query[queryParamName] = slugs.join(',')
    }

    router.replace({ query })
  })

  return {
    filterAll,
    selectedSlugs,
    onAllChange,
    onTermChange,
  }
}
